import React, { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../context/GlobalContext";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { auth } from "../config/firebase";
import { signOut } from "firebase/auth";
import axios from "axios";
import Swal from "sweetalert2";

export default function Dashboard2() {
  let navigate = useNavigate();
  // const [data, setData] = useState(null);
  // const [fetchStatus, setFetchStatus] = useState(true);

  // useEffect(() => {
  //   if (fetchStatus === true) {
  //     axios
  //       .get("https://dev-example.sanbercloud.com/api/job-vacancy")
  //       .then((res) => {
  //         setData([...res.data.data]);
  //       })
  //       .catch((error) => {});
  //     setFetchStatus(false);
  //   }
  // }, [fetchStatus, setFetchStatus]);

  // console.log(data);

  const onLogout = async () => {
    try {
      await signOut(auth);
      Cookies.remove("token");
      navigate("/login");
    } catch (error) {
      console.log(error);
    }
  };

  function add3Dots(string, limit) {
    var dots = "...";
    if (string.length > limit) {
      string = string.substring(0, limit) + dots;
    }
    return string;
  }

  // const handleDelete = (event) => {
  //   let idData = parseInt(event.target.value);
  //   let token = Cookies.get("token");

  //   Swal.fire({
  //     title: "Are you sure?",
  //     text: "You won't be able to revert this!",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#3085d6",
  //     cancelButtonColor: "#d33",
  //     confirmButtonText: "Yes, delete it!",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       axios
  //         .delete(
  //           `https://dev-example.sanbercloud.com/api/job-vacancy/${idData}`,
  //           {
  //             headers: {
  //               authorization: `Bearer ${token}`,
  //             },
  //           }
  //         )

  //         .then((res) => {
  //           setFetchStatus(true);
  //         })
  //         .catch((error) => {
  //           alert(error);
  //         });
  //       Swal.fire("Deleted!", "Your file has been deleted.", "success");
  //     }
  //   });
  // };

  const { state, handleFunction } = useContext(GlobalContext);
  const { data } = state;
  const { handleDelete, handleEdit } = handleFunction;

  return (
    <>
      <div className="flex flex-row">
        <aside className="w-48 h-screen" aria-label="Sidebar">
          <div className="overflow-y-auto py-4 px-3 bg-gray-800 h-screen">
            <ul className="space-y-2">
              <li>
                <Link
                  to={"/dashboard/"}
                  className="flex items-center p-2 text-base font-normal rounded-lg text-white hover:bg-gray-700"
                >
                  <svg
                    aria-hidden="true"
                    className="w-6 h-6 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M2 10a8 8 0 018-8v8h8a8 8 0 11-16 0z" />
                    <path d="M12 2.252A8.014 8.014 0 0117.748 8H12V2.252z" />
                  </svg>
                  <span className="ml-3">Dashboard</span>
                </Link>
              </li>
              <li>
                <Link
                  to={"/dashboard/list-job-vacancy"}
                  className="flex items-center p-2 text-base font-normal rounded-lg text-white hover:bg-gray-700"
                >
                  <svg
                    aria-hidden="true"
                    className="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 2a4 4 0 00-4 4v1H5a1 1 0 00-.994.89l-1 9A1 1 0 004 18h12a1 1 0 00.994-1.11l-1-9A1 1 0 0015 7h-1V6a4 4 0 00-4-4zm2 5V6a2 2 0 10-4 0v1h4zm-6 3a1 1 0 112 0 1 1 0 01-2 0zm7-1a1 1 0 100 2 1 1 0 000-2z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                  <span className="ml-3">List Job Table</span>
                </Link>
              </li>
              <li>
                <Link
                  to={"/dashboard/list-job-vacancy/create"}
                  className="flex items-center p-2 text-base font-normal rounded-lg text-white hover:bg-gray-700"
                >
                  <svg
                    aria-hidden="true"
                    className="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
                  </svg>
                  <span className="flex-1 ml-3 whitespace-nowrap">
                    Add new Job
                  </span>
                </Link>
              </li>
              {Cookies.get("token") && (
                <li>
                  <span
                    className="cursor-pointer flex items-center p-2 text-base font-normal rounded-lg text-white hover:bg-gray-700"
                    onClick={onLogout}
                  >
                    <svg
                      aria-hidden="true"
                      className="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                    <span className="flex-1 ml-3 whitespace-nowrap">
                      Logout
                    </span>
                  </span>
                </li>
              )}
            </ul>
          </div>
        </aside>

        <div className="overflow-x-auto relative w-full h-max">
          <table className="w-full h-full text-sm text-center text-gray-500 dark:text-gray-400">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="py-2 px-2">
                  No
                </th>
                <th scope="col" className="py-2 px-3">
                  Title
                </th>
                <th scope="col" className="py-2 px-2">
                  Description
                </th>
                <th scope="col" className="py-2 px-2">
                  Qualification
                </th>
                <th scope="col" className="py-2 px-2">
                  Type
                </th>
                <th scope="col" className="py-2 px-2">
                  Tenure
                </th>
                <th scope="col" className="py-2 px-2">
                  Status
                </th>
                <th scope="col" className="py-2 px-2">
                  Company
                </th>
                <th scope="col" className="py-2 px-2">
                  Logo
                </th>
                <th scope="col" className="py-2 px-2">
                  City
                </th>
                <th scope="col" className="py-2 px-2">
                  Salary
                </th>
                <th scope="col" className="py-2 px-2">
                  Action
                </th>
              </tr>
            </thead>

            <tbody>
              {data !== null &&
                data.map((res, index) => {
                  return (
                    <tr
                      key={index}
                      className="bg-gray-100 bg-white text-black border-b"
                    >
                      <td className="py-2 px-2 whitespace-nowrap text-sm font-medium">
                        {index + 1}
                      </td>
                      <th scope="row" class="py-2 px-2 whitespace-nowrap">
                        {res.title}
                      </th>
                      <td class="py-2 px-2">
                        {add3Dots(res.job_description, 15)}
                      </td>
                      <td class="py-2 px-2">
                        {add3Dots(res.job_qualification, 15)}
                      </td>
                      <td class="py-2 px-2">{res.job_type}</td>
                      <td class="py-2 px-2">{res.job_tenure}</td>
                      <td class="py-2 px-2">{res.job_status}</td>
                      <td class="py-2 px-2">{res.company_name}</td>
                      <td class="py-2 px-2">
                        <img
                          className="py-2 px-2"
                          style={{
                            resizeMode: "contain",
                            height: 50,
                            width: 50,
                          }}
                          src={res.company_image_url}
                          alt="company image"
                        />
                      </td>
                      <td class="py-2 px-2">{res.company_city}</td>
                      <td class="py-2 px-2">
                        {res.salary_min} {"-"} {res.salary_max}
                      </td>

                      <td className="py-2 px-2">
                        <td>
                          <button
                            className="bg-gray-200 hover:bg-slate-300 text-black font-bold py-2 px-3 w-12 border border-black-700 rounded"
                            onClick={handleEdit}
                            value={res.id}
                          >
                            Edit
                          </button>
                        </td>
                        <td>
                          <button
                            className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-3 w-16 ml-4 border border-red-700 rounded"
                            onClick={handleDelete}
                            value={res.id}
                          >
                            Delete
                          </button>
                        </td>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
